import css from "classnames";
import * as React from "react";

import { EventPointList } from "../Soccer/SoccerLive/model";

const styles = require("./styles.scss"); // tslint:disable-line no-var-requires

interface Props {
    data?: EventPointList[];
}

interface State {
    openPitch: boolean;
}

class ScorePitch extends React.Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = { openPitch: false };
        this.clickHandler = this.clickHandler.bind(this);
    }

    public render(): JSX.Element | null {
        const eventList = this.props.data;

        if (!eventList || eventList.length === 0) {
            return null;
        }

        const pitchColumnCss = css(
            styles.pitchColumn,
            eventList.length > 1 ? styles.arrow : "",
            this.state.openPitch ? styles.up : ""
        );

        const team1Event = eventList[0].evTeam1 ? (
            <span>
                {eventList[0].evTeam1} ({eventList[0].score})
            </span>
        ) : null;
        const team2Event = eventList[0].evTeam2 ? (
            <span className={css(styles.eventRight)}>
                {eventList[0].evTeam2} ({eventList[0].score})
            </span>
        ) : null;
        const pitchContainerCSS = css(
            styles.pitchContainer,
            this.state.openPitch ? "" : styles.hide
        );

        return (
            <section className={css(styles.scorePitch)}>
                <div
                    className={css(styles.pitchRow, styles.topSection)}
                    onClick={this.clickHandler}
                >
                    <div className={css(styles.pitchColumn, styles.pitchRight)}>
                        {team1Event}
                    </div>
                    <div className={styles.minute}>{eventList[0].minute}</div>
                    <div className={pitchColumnCss}>{team2Event}</div>
                </div>
                <ul className={pitchContainerCSS}>
                    {this.renderScoreList(eventList)}
                </ul>
            </section>
        );
    }

    private renderScoreList(pointList: EventPointList[]) {
        const [, ...rest] = pointList.map((event, index) => {
            const pitchRightColCSS = css(styles.pitchColumn, styles.pitchRight);
            if (event.evTeam1 !== "" && event.isHt === false) {
                return (
                    <li key={index} className={styles.pitchRow}>
                        <div className={pitchRightColCSS}>
                            {event.evTeam1} ({event.score})
                        </div>
                        <div className={styles.pitchSquare}>{event.minute}</div>
                        <div className={styles.pitchColumn}>
                            {event.evTeam2}
                        </div>
                    </li>
                );
            } else if (event.isHt === true) {
                const pitchSquareCSS = css(
                    styles.pitchSquare,
                    styles.transparent
                );
                return (
                    <li
                        key={index}
                        className={css(styles.pitchRow, styles.pitchHT)}
                    >
                        <div className={css(styles.pitchColumn)} />
                        <div className={pitchSquareCSS}>{event.minute}</div>
                        <div className={css(styles.pitchColumn)} />
                    </li>
                );
            } else {
                return (
                    <li key={index} className={styles.pitchRow}>
                        <div className={pitchRightColCSS}>{event.evTeam1}</div>
                        <div className={styles.pitchSquare}>{event.minute}</div>
                        <div className={styles.pitchColumn}>
                            {event.evTeam2} ({event.score})
                        </div>
                    </li>
                );
            }
        });

        return rest;
    }

    private clickHandler(): void {
        if (this.props && this.props.data && this.props.data.length <= 1) {
            return;
        }
        this.setState({ openPitch: !this.state.openPitch });
    }
}

export default ScorePitch;
